package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px


val MotivationSectionStyle = CssStyle {
    base          { Modifier.margin(top = 30.px, bottom = 40.px) }
    Breakpoint.MD { Modifier.margin(top = 40.px, bottom = 90.px) }
}

val MotivationTitleStyle = CssStyle {
    base          { Modifier.fontSize(18.px).whiteSpace(WhiteSpace.PreWrap) }
    Breakpoint.MD { Modifier.fontSize(30.px).whiteSpace(WhiteSpace.Normal) }
}

val MotivationSubtitleStyle = CssStyle {
    base          { Modifier.fontSize(18.px).whiteSpace(WhiteSpace.PreWrap).margin(bottom = 30.px) }
    Breakpoint.MD { Modifier.fontSize(30.px).whiteSpace(WhiteSpace.Normal).margin(bottom = 60.px) }
}

val LetterRowStyle = CssStyle {
    base          { Modifier.gap(30.px).padding(leftRight = 60.px).margin(bottom = 20.px) }
    Breakpoint.MD { Modifier.margin(bottom = 50.px) }
}

val LetterCarouselWrapperStyle = CssStyle {
    base          { Modifier.margin(bottom = 15.px) }
    Breakpoint.MD { Modifier.margin(bottom = 30.px) }
}

val ViewMoreButtonStyle = CssStyle {
    base          { Modifier.fontSize(15.px).padding(topBottom = 15.px, leftRight = 10.px) }
    Breakpoint.MD { Modifier.fontSize(30.px).padding(topBottom = 40.px, leftRight = 35.px) }
}

val ViewMoreArrowStyle = CssStyle {
    base          { Modifier.styleModifier { property("height", "20px") } }
    Breakpoint.MD { Modifier.styleModifier { property("height", "40px") } }
}